import { jsx as _jsx } from "react/jsx-runtime";
import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import flashSale from "@faire/web-api--source/routes/flash-sale";
import { observer } from "mobx-react";
import * as React from "react";
import { getIsApparelRetailer } from "@faire/retailer/serialized-data/getIsApparelRetailer";
var WarehouseSaleBannerBase = function() {
    return /*#__PURE__*/ _jsx(Typography, {
        align: "center",
        children: /*#__PURE__*/ _jsx(ResponsiveContentV2, {
            mobile: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "htTBVp",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy up to 60% off!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " "
                    },
                    {
                        type: 8,
                        value: "LinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Shop Warehouse Sale"
                            }
                        ]
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    LinkFormatting: LinkFormatting
                }
            }),
            tabletAndAbove: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "aFHSiQ",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Our Warehouse Sale is happening now!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Enjoy up to 60% off. "
                    },
                    {
                        type: 8,
                        value: "LinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Shop now"
                            }
                        ]
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    LinkFormatting: LinkFormatting
                }
            })
        })
    });
};
var LinkFormatting = function(chunk) {
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: getIsApparelRetailer() ? flashSale({
            "seasonal-warehouse-sales": "1",
            filters: "category:apparel"
        }) : flashSale({
            "seasonal-warehouse-sales": "1"
        }),
        children: chunk
    });
};
export var WarehouseSaleBanner = observer(WarehouseSaleBannerBase);
